import { render } from "./RefundPolicyPage.vue?vue&type=template&id=7224f2ff"
import script from "./RefundPolicyPage.vue?vue&type=script&lang=js"
export * from "./RefundPolicyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__